import { render, staticRenderFns } from "./ApiTokenCard.vue?vue&type=template&id=f0830582&scoped=true"
import script from "./ApiTokenCard.vue?vue&type=script&lang=js"
export * from "./ApiTokenCard.vue?vue&type=script&lang=js"
import style0 from "./ApiTokenCard.vue?vue&type=style&index=0&id=f0830582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0830582",
  null
  
)

export default component.exports